var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0833 11.6667H2.91667C2.60725 11.6667 2.3105 11.5438 2.09171 11.325C1.87292 11.1062 1.75 10.8095 1.75 10.5V5.25004C1.75 4.94062 1.87292 4.64388 2.09171 4.42508C2.3105 4.20629 2.60725 4.08337 2.91667 4.08337H11.0833C11.3928 4.08337 11.6895 4.20629 11.9083 4.42508C12.1271 4.64388 12.25 4.94062 12.25 5.25004V10.5C12.25 10.8095 12.1271 11.1062 11.9083 11.325C11.6895 11.5438 11.3928 11.6667 11.0833 11.6667Z",
    stroke: "#E8E8E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.62492 8.16671C9.54756 8.16671 9.47338 8.13598 9.41868 8.08128C9.36398 8.02658 9.33325 7.9524 9.33325 7.87504C9.33325 7.79769 9.36398 7.7235 9.41868 7.6688C9.47338 7.6141 9.54756 7.58337 9.62492 7.58337C9.70227 7.58337 9.77646 7.6141 9.83116 7.6688C9.88586 7.7235 9.91659 7.79769 9.91659 7.87504C9.91659 7.9524 9.88586 8.02658 9.83116 8.08128C9.77646 8.13598 9.70227 8.16671 9.62492 8.16671Z",
    fill: "#E8E8E8",
    stroke: "#E8E8E8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 4.08331V3.26839C10.4999 3.0896 10.4588 2.91322 10.3798 2.75285C10.3007 2.59249 10.1858 2.45244 10.0441 2.34352C9.90227 2.23461 9.73735 2.15973 9.56203 2.12469C9.38671 2.08964 9.20568 2.09535 9.03292 2.14139L2.61625 3.85231C2.36778 3.91852 2.14815 4.06497 1.99149 4.26888C1.83484 4.4728 1.74994 4.72275 1.75 4.97989V5.24998",
    stroke: "#E8E8E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBet);
export default __webpack_public_path__ + "static/media/bet.d65597a815300b9e2c1359cf016aca43.svg";
export { ForwardRef as ReactComponent };